import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { Fornecedor } from '../models/fornecedor';
import { CarregandoService } from '../services/carregando.service';
import { FornecedorService } from '../services/fornecedor.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { CadastrarFornecedorComponent } from './cadastrar-fornecedor/cadastrar-fornecedor.component';
import { PremissasService } from '../services/premissas.service';
import { PaginatorService } from '../services/paginator.service';
import { IbgeService } from '../services/ibge.service';

declare const $: any;

@Component({
  selector: 'app-fornecedor',
  templateUrl: './fornecedor.component.html',
  styleUrls: ['./fornecedor.component.scss']
})
export class FornecedorComponent implements OnInit, OnDestroy {

  // variáveis
  fornecedoresFiltrados: Fornecedor[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  pCentroDistribuicao = false;
  titulo = '';

  selectedFile: File;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private fornecedorService: FornecedorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private premissasService: PremissasService,
    private paginatorService: PaginatorService,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarFornecedores();
    this.buscarPremissaCentroDeDistribuicao();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarFornecedores();
    this.paginator.firstPage();
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(f => {
      this.pCentroDistribuicao = f.valor;
      this.titulo = this.pCentroDistribuicao ? 'Centros de Distribuição' : 'Fornecedores';

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    });
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscaFornecedores');
    this.carregando = true;

    this.fornecedorService.consultarFornecedoresComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
        this.fornecedoresFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaFornecedores');
      }, (erro) => {
        this.carregandoService.esconde('buscaFornecedores');
        this.notificacaoService.erro(erro);
      });
  }

  editarFornecedor(fornecedor: Fornecedor) {
    this.router.navigate(['editar', fornecedor.id], { relativeTo: this.route });
  }

  excluirFornecedor(fornecedor: Fornecedor) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Tabela?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiFornecedor');
        this.fornecedorService.excluir(fornecedor.id).subscribe(resp => {
          this.notificacaoService.sucesso('Tabela excluída com sucesso!!!');
          this.carregandoService.esconde('excluiFornecedor');
          this.filtra();

        }, (erro) => {
          this.carregandoService.esconde('excluiFornecedor');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize) {
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);
    }

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFornecedores();
  }

  exportar() {
    this.carregandoService.mostra('exportaCidades');
    this.ibgeService.exportar(this.filtroNome.Valor, null, null).subscribe(
      (arq: Blob) => {
        const nomeArquivo = 'Cidades_CD.xlsx';

        this.utilitarioService.saveBlob(arq, nomeArquivo);
        this.carregandoService.esconde('exportaCidades');
      },
      (erro) => {
        this.carregandoService.esconde('exportaCidades');
        this.notificacaoService.erro(erro.error);
      }
    );
  }

  importar() {
    const dados = new FormData();

    if (!this.selectedFile) {
      this.notificacaoService.aviso('Selecione um arquivo para importar!');
      return;
    }

    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('importar');
    this.ibgeService.importar(dados).subscribe((resp) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.sucesso('Dados importados com sucesso!!!');
    }, (erro) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.erro(erro);
    });
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
  }

  ngOnDestroy(): void { }
}
